import styled from 'styled-components';

export const ProjectOptionStyled = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 8px;
`;

export const ProjectIconStyled = styled.img`
  width: 16px;
  height: 16px;
  border-radius: 3px;
  margin-left: 1px;
`;
